import { Address } from 'viem';

export const DVstETHTokenAddress: Address = '0x5E362eb2c0706Bd1d134689eC75176018385430B';
